import React from 'react';
import MaskedInput from 'react-maskedinput';

export default function UniqueRegisterSeriesInput(props) {
  return <MaskedInput mask="11111111-11111" placeholder="" {...props} />;
}
